import './utils/tooltips'
import './utils/toggles'
import './utils/tabs'
// import './utils/darkmode'
import './utils/smooth-scroll'
import './utils/load-more'
import './utils/modal'
import './utils/popup'
import './utils/video'
import './utils/preview'
import './utils/sliders'
import './menu/menu-btns'
import './utils/gravity-form-inputs'
import '../../includes/acf/lightning-builder/page-components/pc-post-listing/js/testimonials'
import '../../includes/acf/lightning-builder/page-components/pc-sticky-menu/js/sticky-menu'
import '../../includes/acf/lightning-builder/page-components/pc-post-listing/js/filters'
import '../../includes/acf/lightning-builder/page-components/pc-document-list/js/document-filter'
import '../../includes/acf/lightning-builder/page-components/pc-animate-numbers/js/animate-numbers'
import '../../includes/acf/lightning-builder/page-components/pc-cert-finder/js/cert-finder'
import '../../includes/acf/lightning-builder/page-components/pc-certificate-search/js/certificate-search'
import '../../includes/acf/lightning-builder/page-components/pc-certificate-control/js/certificate-control'
import '../../includes/acf/lightning-builder/page-components/pc-register-company/js/register-company'
import '../../includes/acf/lightning-builder/page-components/pc-register-user/js/register-user'
import '../../includes/acf/lightning-builder/page-components/pc-tabs/js/pc-tabs'
// css
import '../css/app.css'

if (module.hot) {
    module.hot.accept()
}
